import React from 'react';
import './Home.css';
import {Carousel, } from 'react-bootstrap';

const Corosel = () => {
    return ( 
        <div>
          <Carousel>
            <Carousel.Item>
               <img
                  className="d-block w-100"
                  src="https://res.cloudinary.com/dr0cgsqke/image/upload/v1611596748/nonedb/volvo_chzrsn.jpg"
                  alt="Third slide"
               />

                   <Carousel.Caption>
                      <h3><span className="stylez">Volvo Trucks</span></h3>
                      <p><span className="stylez">We supply spares for Volvo Trucks!</span></p>
                  </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
               <img
                   className="d-block w-100"
                   src="https://res.cloudinary.com/dr0cgsqke/image/upload/v1611596746/nonedb/man_y64wjn.jpg"
                   alt="Third slide"
            />

                   <Carousel.Caption>
                      <h3><span className="stylez">MAN Trucks</span></h3>
                      <p><span className="stylez">We supply spares for MAN Trucks!</span></p>
                   </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img
                 className="d-block w-100"
                 src="https://res.cloudinary.com/dr0cgsqke/image/upload/v1611596747/nonedb/scania_hqehgb.jpg"
                 alt="First slide"
              />
                  <Carousel.Caption>
                    <h3><span className="stylez">Scania Trucks</span></h3>
                    <p><span className="stylez">We supply spares for Scania Trucks!</span></p>
                    </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img
                 className="d-block w-100"
                 src="https://res.cloudinary.com/dr0cgsqke/image/upload/v1611596747/nonedb/vehicles_xvtdui.jpg"
                 alt="First slide"
              />
                  <Carousel.Caption>
                    <h3><span className="stylez">Special Vehicles</span></h3>
                    <p><span className="stylez">We supply Utility and Security Vehicles!</span></p>
                    </Carousel.Caption>
            </Carousel.Item>
          </Carousel>
        </div>
     );
}
 
export default Corosel;